import React, { useEffect } from 'react'
import { COPY_STRINGS } from '../../../../constants/translatedCopy'
import { amiraGestures } from '../../../Coach/GesturedSpeech'
import StudentInstruction from "../../Components/StudentInstruction"

import checkGif from '../../../../../assets/studentPreChecks/check.gif'
import { GetBrandedAppName } from '../../../../services/BrandingService'
import { getCopyByGradeband } from '../../../../services/ThemingService'

export default React.memo(function ReloadPageToApplyPermission(props) {

    const { speechProps, toggleReaderContainer, failureReturnUrl } = props

    useEffect(() => {
        toggleReaderContainer()
        const playRestartSpeech = () => {
            speechProps.abortDance()
            speechProps.playDance({
                gesture: amiraGestures.PointingWithChalk
            })
            speechProps.speak({
                textToSpeak: getCopyByGradeband(COPY_STRINGS, 'student_checks').student_hardware_manually_fixed
            })
        }
        speechProps.abortSpeech(playRestartSpeech)

        return () => {
            toggleReaderContainer()
        }
    }, [])

    const handleReload = () => {
        if (failureReturnUrl) {
            window.location.href = failureReturnUrl;
        } else {
            location.reload();
        }
    }

    return <div>
        <StudentInstruction>
            <div className="instruction-image"><img src={checkGif} alt=""/></div>
            <h2>Thanks! To continue, please close and re-start {GetBrandedAppName()}.</h2>
            {failureReturnUrl && (
                <>
                    <p>Please reload the page to apply the change.</p>
                    <button onClick={handleReload}>Continue</button>
                </>
            )}
        </StudentInstruction>
    </div>
})